<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="30%">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                     <el-form-item prop="name" label="岗位名称">
                        <el-input v-model="form.name" maxlength="200" style="width:190px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="200" type="number" style="width:190px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>

    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格
    
    export default {
        data(){
            return{
                visible: false,
                form:{
                    name:"",
                    deptId:"",
                    orderNum:1
                },
                depts: {},
                rules: {
                    name: [
                        { required: true, message: '请输入岗位名称', trigger: 'blur' }
                    ],
                    deptId: [
                        { required: true, message: '请选择所属组织', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
            //获取一级组织
            this.getDept();
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.deptId=data.deptId;
                this.form.orderNum=data.orderNum;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.postUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            deptId:this.form.deptId,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/base/post/Update.vue